module.exports = __webpack_public_path__ + "static/media/icon.a8e44fe0.png";